import { Monitor, Moon, Sun } from 'lucide-react'
import { useTheme, type Mode } from '@/admin-design/_common/theme/ThemeProvider'
import { cn } from '@/lib/utils'

const MODES: { mode: Mode; label: string; icon: typeof Sun }[] = [
  { mode: 'light', label: '라이트', icon: Sun },
  { mode: 'dark', label: '다크', icon: Moon },
  { mode: 'system', label: '시스템', icon: Monitor },
]

/** Light / dark / follow the system. `compact` is one button that cycles,
 *  for the collapsed sidebar. */
export function ThemeSwitch({ compact, className }: { compact?: boolean; className?: string }) {
  const { mode, setMode } = useTheme()
  if (compact) {
    const i = MODES.findIndex((m) => m.mode === mode)
    const cur = MODES[i < 0 ? 2 : i]
    const next = MODES[(i + 1) % MODES.length]
    return (
      <button
        type="button"
        onClick={() => setMode(next.mode)}
        aria-label={`화면 테마: ${cur.label}. 눌러서 ${next.label}로`}
        title={`테마: ${cur.label}`}
        className={cn(
          'inline-flex h-9 w-9 items-center justify-center rounded-md text-sidebar-muted hover:bg-sidebar-hover hover:text-sidebar-foreground',
          className,
        )}
      >
        <cur.icon size={16} aria-hidden />
      </button>
    )
  }
  return (
    <div role="radiogroup" aria-label="화면 테마" className={cn('flex rounded-md bg-sidebar-hover p-0.5', className)}>
      {MODES.map(({ mode: m, label, icon: Icon }) => {
        const on = m === mode
        return (
          <button
            key={m}
            type="button"
            role="radio"
            aria-checked={on}
            onClick={() => setMode(m)}
            title={label}
            className={cn(
              'inline-flex h-7 flex-1 items-center justify-center gap-1 rounded-[5px] text-meta transition-colors',
              on ? 'bg-card text-sidebar-foreground shadow-sm' : 'text-sidebar-muted hover:text-sidebar-foreground',
            )}
          >
            <Icon size={13} aria-hidden />
            {label}
          </button>
        )
      })}
    </div>
  )
}
